import { functions, isEqual, omit } from 'lodash'
import React, { useState, useEffect, useRef } from 'react'
import actions from "../api";
import "./GoogleMap.css";


function Map({ options, onMount, className, onMountProps }) {
  
  // useEffect(() => {
  //   actions.getLocation().then((res) => {
  //     setMap(res.data.googleUser);
  //   })
  // }, [])

    const ref = useRef()
  const [map, setMap] = useState([])
  useEffect(() => {
    const onLoad = () =>
      setMap(new window.google.maps.Map(ref.current, { ...options }))
    if (!window.google) {
      const script = document.createElement(`script`)
      script.src =
        `https://maps.googleapis.com/maps/api/js?key=` +
        // process.env.GOOGLE_MAPS_API_KEY
        'AIzaSyA2IX8Vvplh3mUsonvv7OeXdDBNcZWYHuE'
        

        
      document.head.append(script)
      script.addEventListener(`load`, onLoad)
      return () => script.removeEventListener(`load`, onLoad)
    } else onLoad()
  }, [options])
  if (map && typeof onMount === `function`) onMount(map, onMountProps)
  return (
    <div
      style={{ height: `60vh`, margin: `1em 0`, borderRadius: `0.5em` }}
      {...{ ref, className }}
    />
  )
}

function shouldNotUpdate(props, nextProps) {
  const [funcs, nextFuncs] = [functions(props), functions(nextProps)]
  const noPropChange = isEqual(omit(props, funcs), omit(nextProps, nextFuncs))
  const noFuncChange =
    funcs.length === nextFuncs.length &&
    funcs.every(fn => props[fn].toString() === nextProps[fn].toString())
  return noPropChange && noFuncChange
}
export default React.memo(Map, shouldNotUpdate)
Map.defaultProps = {
  options: {
    center: { lat: 25.76712, lng: -80.19609 },
    zoom: 15,
  },
}


//DELIVERY TRACKER
// const link = {
//   coords: { lat: 42, lng: 42 },
// }

// function addMarkers(map, links) {
//   links.forEach((link, index) => {
//     const marker = new window.google.maps.Marker({
//       map,
//       position: link.coords,
//       label: `${index + 1}`,
//       title: link.title,
//     })
//     marker.addListener(`click`, () => {
//       window.location.href = link.url
//     })
//   })
// }

// const mapProps = {
//   options: { center: { lat: 20, lng: 40 }, zoom: 4 },
//   onMount: addMarkers, 
//   onMountProps: googleSchema,
//   // 'linksComingFromSomewhere', 
// }


// export default GoogleMap2;






// import { Map, GoogleApiWrapper } from 'google-maps-react';

// const mapStyles = {
//   width: '100%',
//   height: '100%',
// };

// render() 
// {
//   return (
//       <Map
//         google={this.props.google}
//         zoom={8}
//         style={mapStyles}
//         initialCenter={{ lat: 47.444, lng: -122.176}}
//       >
//         <Marker position={{ lat: 48.00, lng: -122.00}} />
//       </Map>
//   );
// }
  
  
//   export default GoogleApiWrapper({
//     apiKey: 'AIzaSyA2IX8Vvplh3mUsonvv7OeXdDBNcZWYHuE'
//   })(MapContainer);

//   import React from 'react';
  
//   function GoogleMap2(props) {
//     return (
//       <div>
        
//       </div>
//     );
//   }
  
//   export default GoogleMap2;